import { BankDetailsDepositsHistoryPanel } from "@/components/organisms";

export const BankDetailsDepositsHistory = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <BankDetailsDepositsHistoryPanel />
    </div>
  );
};
